/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import { useSelector } from 'react-redux';
import { Route, Redirect } from 'react-router-dom';

function PrivateRoute({ component: Component, ...rest }) {
  const authToken = useSelector(({ auth }) => auth.token);
  const isBot = typeof window !== 'undefined' && window.__IS_BOT__;

  return (
    <Route
      {...rest}
      render={(props) =>
        authToken || isBot ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: '/' }} />
        )
      }
    />
  );
}

export default PrivateRoute;
